@if(isLoading)
{
<div class="d-flex flex-column justify-content-center align-items-center w-100 vh-80">
    <div class="continuous-loader" role="status"></div>
    <h4 class="mt-2">Indlæser data</h4>
</div>
}
@else
{
<div class="card card-no-border mt-4" style="flex: 1 1 auto;">
    <div class="card-body no-padding">
        <div class="row col-12">
            <div class="col-6">
                <div class="input-group">
                    <div class="fw-bold card-title mt-2">Stamdata for id: {{ dbTemplateInfo.dbTemplate.id }} <br> 
                        {{ dialogDbCaption }}
                    </div>
                </div>
            </div>
            <div class="col-2"></div>
            <div class="col-4">
                <div class="d-flex justify-content-end mt-2">
                    <div class="form-check form-switch mt-2">
                        <input class="form-check-input" type="checkbox" id="enabled" (click)="onDisable()"
                            [(ngModel)]="dbTemplateInfo.dbTemplate.enabled">
                        <label class="form-check-label" for="enabled">Aktiv</label>
                    </div>
                    <div class="ms-4"></div>
                    <button class="btn btn-success position-relative"
                        [disabled]="!dbTemplateInfo.dbTemplate.id || templateWorkingText != '' || awaitingNetworkResponse"
                        [ngbTooltip]="isDirty() ? 'Der er ændringer, som ikke er gemt' : ''"
                        (click)="onUpdateTemplate()">
                        @if (isDirty()) {
                        <span class="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
                            <span class="visually-hidden">Ugemte ændringer</span>
                        </span>
                        }
                        @if(awaitingNetworkResponse)
                        {
                        <div class="spinner-border spinner-border-sm me-2" role="status">
                            <span class="visually-hidden">Gemmer...</span>
                        </div>
                        }
                        Gem skabelon
                    </button>
                    <div class="ms-2"></div>
                    <button class="btn btn-primary" [disabled]="!dbTemplateInfo.dbTemplate.id || templateWorkingText != ''"
                        (click)="onShowProperties()" ngbTooltip="Vis egenskaber for skabelon">
                        <i class="fa-regular fa-gear"></i>
                    </button>
                    <div class="ms-2"></div>
                    <button class="btn btn-primary"
                        [disabled]="!dbTemplateInfo.dbTemplate.id || templateWorkingText != '' || !dbTemplateInfo.dbTemplate.allowRead && !dbTemplateInfo.dbTemplate.allowDelete"
                        (click)="onShowFilter()" ngbTooltip="Filtre (læs og slet)">
                        <i class="fa-regular fa-filter"></i>
                    </button>
                    <div class="ms-2"></div>
                    <button class="btn btn-primary" [disabled]="!dbTemplateInfo.dbTemplate.id || templateWorkingText != '' || awaitingNetworkResponse"
                        (click)="onCheckDatabase()" ngbTooltip="Tjek databasetabel" aria-label="Tjek databasetabel">
                        <i class="fa-regular fa-database" aria-hidden="true"></i>
                    </button>
                    <div class="ms-2"></div>
                    <button class="btn btn-primary" [disabled]="!dbTemplateInfo.dbTemplate.id || templateWorkingText != ''"
                        (click)="onShowtemplateinfo()" ngbTooltip="Vis information">
                        <i class="fa-regular fa-info"></i>
                    </button>
                    <div class="ms-2"></div>
                    <button class="btn btn-danger"
                        [disabled]="!dbTemplateInfo.dbTemplate.id || isEnabled || templateWorkingText != '' || awaitingNetworkResponse"
                        (click)="onDeletetemplate()" ngbTooltip="Slet skabelon">
                        <i class="fa-regular fa-trash"></i>
                    </button>
                    <div class="ms-2"></div>
                    <button class="btn btn-primary" [disabled]="awaitingNetworkResponse || templateWorkingText != ''"
                        (click)="onGoBack()" ngbTooltip="Tilbage til liste">
                        <i class="fa-regular fa-arrow-left"></i>
                    </button>
                </div>
            </div>
            <hr />

            <div class="row">
                <div class=col-sm-3>
                    <div class="input-group">
                        <span class="input-group-text" id="navn">Navn:</span>
                        <input type="text" class="form-control" id="DbObject-name" aria-describedby="navn"
                            [(ngModel)]="dbTemplateInfo.dbTemplate.name">
                    </div>
                </div>
                <div class=col-sm-3>
                    <div class="input-group">
                        <span class="input-group-text" id="vist-navn">Vist navn: </span>
                        <input type="text" class="form-control" id="DbObject-displayname" aria-describedby="vist-navn"
                            [(ngModel)]="dbTemplateInfo.dbTemplate.displayName">
                    </div>
                </div>
                <div class=col-sm-6>
                    <div class="input-group" (click)="onShowProperties()" [ngbTooltip]="propertiesInfoTooltip">
                        <span class="input-group-text" id="navn"><i class="fa-regular fa-gear"></i></span>
                        <input type="text" class="form-control" id="DbObject-name" aria-describedby="navn" readonly
                            [(ngModel)]="propertiesInfo">
                    </div>
                </div>
            </div>
            <hr class="my-3">
            <div class="row">
                <div class="col">
                    <div class="d-flex align-items-center" style="max-width: 600px;">
                        <span class="fw-bold me-3">Viser felter [{{ filterDbObjectItems().length }}] af [{{
                            dbTemplateInfo.dbTemplateItems.length }}]</span>
                        <div style="flex: 1;">
                            <app-search-input [(searchText)]="searchText" [items]="allDbObjectItems()"
                                [searchFields]="['name', 'dbColumnName', 'dbDataType']" [placeholder]="'Søg felter...'"
                                [ariaLabel]="'Søg felter'" (filteredItemsChange)="onFilteredItems($event)">
                            </app-search-input>
                        </div>
                        @if (dbTemplateInfo.dbTemplate.dbObjectType == dbObjectTypeEnum.StoredProcedure) {
                        <button type="button" class="btn btn-primary ms-2 text-nowrap"
                            [disabled]="!dbTemplateInfo.dbTemplate.id || templateWorkingText != '' || awaitingNetworkResponse"
                            (click)="onAddField()" ngbTooltip="Opret en resultatkolonne, som ikke blev fundet i stored proceduren">
                            <i class="fa-regular fa-plus" aria-hidden="true"></i> Opret felt
                        </button>
                        }
                    </div>
                </div>
            </div>
            <hr class="mt-2" />

        </div>
        <div class="row split-panel-container">
            <!-- Left Panel: Item List -->
            <div class="col-4 pe-0">
                <div class="item-list-panel">
                    @if (filterDbObjectItems().length === 0) {
                        <div class="p-3 text-muted">Ingen felter at vise.</div>
                    } @else {
                        @for (item of filterDbObjectItems(); track item.id) {
                        <div class="item-list-entry"
                             [class.active]="selectedItem() === item"
                             [class.item-disabled]="!item.allowCreate && !item.allowUpdate && !item.allowRead"
                             (click)="selectItem(item)">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center gap-2 text-truncate">
                                    <span class="item-index">{{ filterDbObjectItems().indexOf(item) + 1 }}</span>
                                    <span class="item-name text-truncate" [title]="item.dbColumnName">{{ showNames(item) }}</span>
                                </div>
                                <div class="d-flex align-items-center gap-1">
                                    @if (item.errorMessage) {
                                        <i class="fa-solid fa-triangle-exclamation text-danger fa-sm" [ngbTooltip]="item.errorMessage"></i>
                                    }
                                    @if (item.isSystemField) {
                                        <span class="badge bg-info badge-sm" ngbTooltip="Systemfelt">S</span>
                                    }
                                    @if (!item.allowCreate && !item.allowUpdate && !item.allowRead) {
                                        <i class="fa-regular fa-eye-slash text-muted fa-sm" ngbTooltip="Feltet vil ikke være synligt for skabeloner."></i>
                                    }
                                    @if (item.origin ==  dbDbObjectItemCreatedByEnum.SPInput) {
                                        <span class="badge bg-secondary badge-sm" ngbTooltip="Oprindelse: SP Input">Input</span>
                                    } @else if (item.origin ==  dbDbObjectItemCreatedByEnum.SPOutput) {
                                        <span class="badge bg-secondary badge-sm" ngbTooltip="Oprindelse: SP Output">Output</span>
                                    } @else if (item.origin ==  dbDbObjectItemCreatedByEnum.SPHybrid) {
                                        <span class="badge bg-warning text-dark badge-sm" ngbTooltip="Oprettet manuelt (resultatkolonne, der ikke blev fundet i stored proceduren)">Hybrid</span>
                                    }
                                </div>
                            </div>
                            <div class="item-subtext text-muted">
                                {{ item.dbDataType }}@if (item.dbMaxLength !== null) { ({{ item.dbMaxLength }})}
                            </div>
                        </div>
                        }
                    }
                </div>
            </div>

            <!-- Right Panel: Selected Item Properties -->
            <div class="col-8 ps-0">
                <div class="properties-panel">
                    @if (selectedItem(); as item) {
                        <!-- Section 1: Template Properties -->
                        <div class="property-section db-template-background">
                            <h6 class="section-title">Felt id: {{ item.id }}]</h6>
                            <div class="row g-3">
                                <div class="col-sm-6">
                                    <label class="form-label fw-semibold" for="detail-name">Vist navn</label>
                                    <input type="text" class="form-control" id="detail-name" [(ngModel)]="item.name">
                                </div>
                                <div class="col-sm-6">
                                    <label class="form-label fw-semibold">Defaulttype</label>
                                    @if (item.defaultValueItems.length > 1) {
                                        <select class="form-select" (change)="onDefaultValueTypeChange($event, item)">
                                            @for (option of item.defaultValueItems; track $index) {
                                                <option [selected]="option === item.defaultValueType" [value]="option">{{ option }}</option>
                                            }
                                        </select>
                                    } @else {
                                        <input type="text" class="form-control" disabled [(ngModel)]="item.defaultValueItems[0]">
                                    }
                                </div>
                                <div class="col-12">
                                    <label class="form-label fw-semibold">Defaultværdi</label>
                                    <div class="input-group">
                                        @if (item.dbDataType === 'uniqueidentifier') {
                                            <input type="text" class="form-control" [disabled]="item.isSystemField" [(ngModel)]="item.defaultValue">
                                            <button type="button" [disabled]="item.isSystemField"
                                                class="btn btn-outline-secondary dropdown-toggle"
                                                data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                                <span class="visually-hidden">Vis muligheder</span>
                                            </button>
                                            <ul class="dropdown-menu dropdown-menu-end">
                                                <li><a class="dropdown-item" (click)="onDefaultOption(item, '')">(indtast værdi)</a></li>
                                                @if (item.dbIsNullable) {
                                                    <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Null')">System: Null</a></li>
                                                }
                                                <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Ny UUID')">System: Ny UUID</a></li>
                                                <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Ny Guid')">System: Ny Guid</a></li>
                                                <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Tom Guid')">System: Tom Guid</a></li>
                                            </ul>
                                        } @else if (item.dbDataType === 'bit') {
                                            <input type="text" class="form-control" [disabled]="item.isSystemField" [(ngModel)]="item.defaultValue">
                                            <button type="button" [disabled]="item.isSystemField"
                                                class="btn btn-outline-secondary dropdown-toggle"
                                                data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                                <span class="visually-hidden">Vis muligheder</span>
                                            </button>
                                            <ul class="dropdown-menu dropdown-menu-end">
                                                <li><a class="dropdown-item" (click)="onDefaultOption(item, '')">(indtast værdi)</a></li>
                                                @if (item.dbIsNullable) {
                                                    <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Null')">System: Null</a></li>
                                                }
                                                <li><a class="dropdown-item" (click)="onDefaultOption(item, '0')">False (0)</a></li>
                                                <li><a class="dropdown-item" (click)="onDefaultOption(item, '1')">True (1)</a></li>
                                            </ul>
                                        } @else if (item.dbDataType === 'datetime2' || item.dbDataType === 'datetime') {
                                            <input type="text" class="form-control" [disabled]="item.isSystemField" [(ngModel)]="item.defaultValue">
                                            <button type="button" [disabled]="item.isSystemField"
                                                class="btn btn-outline-secondary dropdown-toggle"
                                                data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                                <span class="visually-hidden">Vis muligheder</span>
                                            </button>
                                            <ul class="dropdown-menu dropdown-menu-end">
                                                <li><a class="dropdown-item" (click)="onDefaultOption(item, '')">(indtast værdi)</a></li>
                                                @if (item.dbIsNullable) {
                                                    <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Null')">System: Null</a></li>
                                                }
                                                <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Nu')">System: Nu</a></li>
                                            </ul>
                                        } @else if (item.dbDataType === 'time') {
                                            <input type="text" class="form-control" [disabled]="item.isSystemField" [(ngModel)]="item.defaultValue">
                                            <button type="button" [disabled]="item.isSystemField"
                                                class="btn btn-outline-secondary dropdown-toggle"
                                                data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                                <span class="visually-hidden">Vis muligheder</span>
                                            </button>
                                            <ul class="dropdown-menu dropdown-menu-end">
                                                <li><a class="dropdown-item" (click)="onDefaultOption(item, '')">(indtast værdi)</a></li>
                                                @if (item.dbIsNullable) {
                                                    <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Null')">System: Null</a></li>
                                                }
                                                <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Nu')">System: Nu</a></li>
                                            </ul>
                                        } @else if (item.dbDataType === 'int' || item.dbDataType === 'decimal') {
                                            <input type="text" class="form-control" [disabled]="item.isSystemField" [(ngModel)]="item.defaultValue">
                                            @if (item.dbIsNullable) {
                                                <button type="button" [disabled]="item.isSystemField"
                                                    class="btn btn-outline-secondary dropdown-toggle"
                                                    data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                                    <span class="visually-hidden">Vis muligheder</span>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end">
                                                    <li><a class="dropdown-item" (click)="onDefaultOption(item, '')">(indtast værdi)</a></li>
                                                    <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Null')">System: Null</a></li>
                                                </ul>
                                            }
                                        } @else if (item.dbDataType === 'nvarchar' || item.dbDataType === 'varchar') {
                                            <input type="text" class="form-control" [disabled]="item.isSystemField" [(ngModel)]="item.defaultValue">
                                            <button type="button" [disabled]="item.isSystemField"
                                                class="btn btn-outline-secondary dropdown-toggle"
                                                data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                                <span class="visually-hidden">Vis muligheder</span>
                                            </button>
                                            <ul class="dropdown-menu dropdown-menu-end">
                                                <li><a class="dropdown-item" (click)="onDefaultOption(item, '')">(indtast værdi)</a></li>
                                                @if (item.dbIsNullable) {
                                                    <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Null')">System: Null</a></li>
                                                }
                                                <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Tom streng')">System: Tom streng</a></li>
                                            </ul>
                                        } @else {
                                            <input type="text" class="form-control" [disabled]="item.isSystemField" [(ngModel)]="item.defaultValue">
                                        }
                                    </div>
                                    @if (item.errorMessage) {
                                        <div class="text-danger mt-1">
                                            <i class="fa-solid fa-triangle-exclamation fa-sm"></i> {{ item.errorMessage }}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <hr class="my-3">

                        <!-- Section 3: Permissions -->
                        <div class="property-section">
                            <h6 class="section-title">Tilladelser</h6>
                            <div class="row g-3">
                                <div class="col-sm-4">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="detail-create"
                                            [(ngModel)]="item.allowCreate" [disabled]="item.isSystemField || isHybrid(item)">
                                        <label class="form-check-label" for="detail-create">Kan oprettes</label>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="detail-update"
                                            [(ngModel)]="item.allowUpdate" [disabled]="item.isSystemField || isHybrid(item)">
                                        <label class="form-check-label" for="detail-update">Kan opdateres</label>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="detail-read"
                                            [(ngModel)]="item.allowRead">
                                        <label class="form-check-label" for="detail-read">Kan læses</label>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="detail-mandatory"
                                            (change)="onMandatoryChange($event, item)" [(ngModel)]="item.mandatory"
                                            [disabled]="item.isSystemField || isHybrid(item)">
                                        <label class="form-check-label" for="detail-mandatory">Obligatorisk</label>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="detail-key"
                                            [disabled]="!item.mandatory" [(ngModel)]="item.isKey">
                                        <label class="form-check-label" for="detail-key">Nøglefelt</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr class="my-3">

                        <!-- Section 3: Database Info -->
                        <div class="property-section db-template-background">
                            <div class="d-flex align-items-center justify-content-between">
                                <h6 class="section-title">Database information</h6>
                                @if (isHybrid(item)) {
                                <button type="button" class="btn btn-outline-danger btn-sm"
                                    [disabled]="templateWorkingText != '' || awaitingNetworkResponse"
                                    (click)="onDeleteField(item)">
                                    <i class="fa-regular fa-trash" aria-hidden="true"></i> Slet felt
                                </button>
                                }
                            </div>
                            <div class="row g-3">
                                <div class="col-sm-6">
                                    <label class="form-label fw-semibold">Kolonne</label>
                                    <div class="form-control-plaintext">{{ item.dbColumnName }}</div>
                                </div>
                                <div class="col-sm-3">
                                    <label class="form-label fw-semibold">Datatype</label>
                                    <div class="form-control-plaintext">{{ item.dbDataType }}</div>
                                </div>
                                <div class="col-sm-3">
                                    <label class="form-label fw-semibold">Max. længde</label>
                                    <div class="form-control-plaintext">{{ item.dbMaxLength ?? '–' }}</div>
                                </div>
                                <div class="col-sm-6">
                                    <label class="form-label fw-semibold">DB Defaultværdi</label>
                                    <div class="form-control-plaintext">{{ item.dbDefaultValue  == null || item.dbDefaultValue === '' ? '–' : item.dbDefaultValue }}</div>
                                </div>
                                <div class="col-sm-3">
                                    <label class="form-label fw-semibold">Nullable</label>
                                    <div class="form-control-plaintext">{{ item.dbIsNullable ? 'Ja' : 'Nej' }}</div>
                                </div>
                                <div class="col-sm-3">
                                    <label class="form-label fw-semibold">Origin</label>
                                    <div class="form-control-plaintext">{{ item.originName }}</div>
                                </div>

                            </div>
                        </div>

                    } @else {
                        <div class="d-flex align-items-center justify-content-center h-100 text-muted">
                            <span>Vælg et felt fra listen til venstre</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div> <!-- card-body -->
</div>
}